import { Button } from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { get } from "lodash";
import React from "react";
import {
	BulkDeleteButton,
	useListContext,
	useNotify,
	useTranslate,
} from "react-admin";
import { CopyToClipboard } from "react-copy-to-clipboard";

// Bulk action: copia "NOME\nLINK" dei canali selezionati, separati da una riga vuota
const CopyLinksButton = ({ selectedIds, network }) => {
	const translate = useTranslate();
	const notify = useNotify();
	const { data } = useListContext();
	const domain = get(network, "channel_domain_name");
	const channels = selectedIds
		.map((id) => data[id])
		.filter((channel) => get(channel, "hash"));
	const text = channels
		.map((channel) => `${channel.name || ""}\nhttps://${domain}/${channel.hash}`)
		.join("\n\n");
	return (
		<CopyToClipboard
			text={text}
			onCopy={() =>
				notify(
					translate("resources.channels.messages.links_copied", {
						count: channels.length,
					})
				)
			}
		>
			<Button
				color="primary"
				size="small"
				startIcon={<FileCopyIcon />}
				disabled={!domain || channels.length === 0}
			>
				{translate("resources.channels.buttons.copy_links")}
			</Button>
		</CopyToClipboard>
	);
};

// BulkActionsToolbar passa selectedIds solo al figlio diretto: niente Fragment
export const ChannelsBulkActions = ({ network, ...props }) => (
	<React.Fragment>
		<CopyLinksButton {...props} network={network} />
		<BulkDeleteButton {...props} />
	</React.Fragment>
);

export default CopyLinksButton;
